import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/documents`
//#region 基本信息
const GetList = `${apiUrl}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const ViewInfo = (id: number) => `${apiUrl}/view/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const GetUserManual = `${apiUrl}/userManual`
const GetVideoWebPlugin = `${apiUrl}/videoWebPlugin`
//#endregion

export const emptyData: DocumentData = {
    Id: 0,
    DocNo: '',
    DocName: '',
    CategoryId: 0,
    FromId: 0,
    DocDate: new Date(),
    Comments: '',
    Status: 1,
    
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    CategoryCode: '',
    CategoryName: '',
    FromName: '',

    AttachType: 0,
    AttachGuid: '',
    AttachPath:''//用于验证
}
export interface DocumentData {
    [key: string]: any
    Id: number
    DocNo: string
    DocName: string
    CategoryId: number
    FromId: number
    DocDate: Date
    Comments: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    CategoryCode: string
    CategoryName: string
    FromName: string

    AttachType: number
    AttachGuid: string
    AttachPath: string//用于验证
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ViewInfo(id),
    })
}
export const getUserManual = () => {
    return tryAxios({
        method: 'get',
        url: GetUserManual,
    })
}
export const getVideoWebPlugin = () => {
    return tryAxios({
        method: 'get',
        url: GetVideoWebPlugin,
    })
}
export const postData = (form: DocumentData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: DocumentData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
